// removed by extract-text-webpack-plugin
module.exports = {"buttons":"_14BBw0zAsofJ1RKjzgeX60","button":"_2g3LRCDtKK6_zhq1QSkZt2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/plannings/Event.scss
// module id = 1645
// module chunks = 0